import { dateUtils } from "components/helpers"
import { ColumnModel } from "components/library"

const dateStartTemplateBody = (rowData): string =>
  dateUtils.formatDateToLocale(rowData.fromDate)

const GrowthLumpSumColumns: ColumnModel[] = [
  {
    field: "id",
    header: "ID",
    sortable: true,
  },
  {
    field: "fromDate",
    header: "Start Date",
    sortable: true,
    body: dateStartTemplateBody,
  },
  {
    field: "statusDescription",
    header: "Status",
    sortable: true,
  },
]

export default GrowthLumpSumColumns
